import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  IconDelivery,
  IconPhone,
  IconPrescription,
  IconTouch,
} from '@redteclab/icons'

import { IconListItem } from 'base-ui'

export const NfcLandingPageHowItWorksSectionSteps: FC = () => {
  return (
    <div>
      <div className="text-s font-medium tablet:text-m">
        <FormattedMessage id="nfc.howItWorks.steps.title" />
      </div>

      <ul className="mt-3 flex flex-col gap-6">
        <IconListItem icon={<IconTouch />}>
          <FormattedMessage id="nfc.howItWorks.steps.openApp" />
        </IconListItem>

        <IconListItem icon={<IconPrescription />}>
          <FormattedMessage id="nfc.howItWorks.steps.cardNumber" />
          <div className="mt-1 rounded-lg bg-light-brand-medium px-4 py-2">
            <FormattedMessage id="nfc.howItWorks.steps.cardNumber.description" />
          </div>
        </IconListItem>

        <IconListItem icon={<IconPhone />}>
          <FormattedMessage id="nfc.howItWorks.steps.2fa" />
        </IconListItem>

        <IconListItem icon={<IconDelivery />}>
          <FormattedMessage id="nfc.howItWorks.steps.delivery" />
        </IconListItem>
      </ul>
    </div>
  )
}
